import React from "react";
import TextField from "@material-ui/core/TextField";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Fuse from "fuse.js";
import { safeParse } from "helpers";


// ==============================
// Payment Method IDs centralizados
// ==============================
export const PAYMENT_METHODS = {
    PAYPAL_EXPRESS: 1,
    PAYPAL_PRO: 2,
    QUANTUS_ONE: 3,
    AUTHORIZE_NET: 8,
    STRIPE: 9,
    GLOBALSHOPEX: 10,
    DLOCAL: 11,
};

// -------------------------------
// Preparamos keys del enum para fuzzy
// -------------------------------
const METHOD_KEYS = Object.keys(PAYMENT_METHODS).map((key) => ({
    key,
    normalized: key.toLowerCase(), // ej: "AUTHORIZE_NET" → "authorize_net"
}));

// Fuzzy engine (85%)
const fuse = new Fuse(METHOD_KEYS, {
    keys: ["normalized"],
    threshold: 0.15, // ≈ 85% similarity
});

const PaymentMethodFields = ({ paymentMethodId, paymentMethodName, formik }) => {
    // -------------------------------
    // 1. Resolver método por NAME primero usando fuzzy
    // -------------------------------
    let resolvedId = null;

    if (paymentMethodName) {
        const term = paymentMethodName.toLowerCase().trim();
        const result = fuse.search(term);

        if (result.length > 0) {
            const matchedKey = result[0].item.key; // ej: "AUTHORIZE_NET"
            resolvedId = PAYMENT_METHODS[matchedKey]; // 8
        }
    }

    // -------------------------------
    // 2. Si name no match, usar id como fallback
    // -------------------------------
    if (!resolvedId && paymentMethodId) {
        resolvedId = paymentMethodId;
    }

    // -------------------------------
    // Parse de credentials
    // -------------------------------
    const gatewayCredentials = safeParse(formik.values.gatewayCredentials, {});


    const handleFieldChange = (field, value) => {
        const updatedCredentials = {
            ...gatewayCredentials,
            [field]: value,
        };
        formik.setFieldValue("gatewayCredentials", JSON.stringify(updatedCredentials));
    };

    // -------------------------------
    // SWITCH ORIGINAL — NO TOCADO
    // -------------------------------
    switch (resolvedId) {
        case PAYMENT_METHODS.PAYPAL_EXPRESS:
            return (
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12} style={{ display: "none" }}>
                        <TextField
                            fullWidth
                            margin="dense"
                            id="apiUrl"
                            name="apiUrl"
                            label="API URL"
                            value={gatewayCredentials?.apiUrl || ""}
                            onChange={(e) => handleFieldChange("apiUrl", e.target.value)}
                            error={
                                formik.touched.gatewayCredentials?.apiUrl &&
                                Boolean(formik.errors.gatewayCredentials?.apiUrl)
                            }
                            helperText={
                                formik.touched.gatewayCredentials?.apiUrl &&
                                formik.errors.gatewayCredentials?.apiUrl
                            }
                        />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                        <TextField
                            fullWidth
                            margin="dense"
                            id="clientId"
                            name="clientId"
                            label="Client ID"
                            value={gatewayCredentials?.clientId || ""}
                            onChange={(e) => handleFieldChange("clientId", e.target.value)}
                            error={
                                formik.touched.gatewayCredentials?.clientId &&
                                Boolean(formik.errors.gatewayCredentials?.clientId)
                            }
                            helperText={
                                formik.touched.gatewayCredentials?.clientId &&
                                formik.errors.gatewayCredentials?.clientId
                            }
                        />
                    </GridItem>
                </GridContainer>
            );

        case PAYMENT_METHODS.PAYPAL_PRO:
            return (
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12} style={{ display: "none" }}>
                        <TextField
                            fullWidth
                            margin="dense"
                            id="apiUrl"
                            name="apiUrl"
                            label="API URL"
                            value={gatewayCredentials?.apiUrl || ""}
                            onChange={(e) => handleFieldChange("apiUrl", e.target.value)}
                            error={
                                formik.touched.gatewayCredentials?.apiUrl &&
                                Boolean(formik.errors.gatewayCredentials?.apiUrl)
                            }
                            helperText={
                                formik.touched.gatewayCredentials?.apiUrl &&
                                formik.errors.gatewayCredentials?.apiUrl
                            }
                        />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={6}>
                        <TextField
                            fullWidth
                            margin="dense"
                            id="user"
                            name="user"
                            label="User"
                            value={gatewayCredentials?.user || ""}
                            onChange={(e) => handleFieldChange("user", e.target.value)}
                            error={
                                formik.touched.gatewayCredentials?.user &&
                                Boolean(formik.errors.gatewayCredentials?.user)
                            }
                            helperText={
                                formik.touched.gatewayCredentials?.user &&
                                formik.errors.gatewayCredentials?.user
                            }
                        />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={6}>
                        <TextField
                            fullWidth
                            margin="dense"
                            id="pwd"
                            name="pwd"
                            label="Password"
                            type="text"
                            value={gatewayCredentials?.pwd || ""}
                            onChange={(e) => handleFieldChange("pwd", e.target.value)}
                            error={
                                formik.touched.gatewayCredentials?.pwd &&
                                Boolean(formik.errors.gatewayCredentials?.pwd)
                            }
                            helperText={
                                formik.touched.gatewayCredentials?.pwd &&
                                formik.errors.gatewayCredentials?.pwd
                            }
                        />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={6}>
                        <TextField
                            fullWidth
                            margin="dense"
                            id="vendor"
                            name="vendor"
                            label="Vendor"
                            value={gatewayCredentials?.vendor || ""}
                            onChange={(e) => handleFieldChange("vendor", e.target.value)}
                            error={
                                formik.touched.gatewayCredentials?.vendor &&
                                Boolean(formik.errors.gatewayCredentials?.vendor)
                            }
                            helperText={
                                formik.touched.gatewayCredentials?.vendor &&
                                formik.errors.gatewayCredentials?.vendor
                            }
                        />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={6}>
                        <TextField
                            fullWidth
                            margin="dense"
                            id="partner"
                            name="partner"
                            label="Partner"
                            value={gatewayCredentials?.partner || ""}
                            onChange={(e) => handleFieldChange("partner", e.target.value)}
                            error={
                                formik.touched.gatewayCredentials?.partner &&
                                Boolean(formik.errors.gatewayCredentials?.partner)
                            }
                            helperText={
                                formik.touched.gatewayCredentials?.partner &&
                                formik.errors.gatewayCredentials?.partner
                            }
                        />
                    </GridItem>
                </GridContainer>
            );

        case PAYMENT_METHODS.QUANTUS_ONE:
            return (
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12} style={{ display: "none" }}>
                        <TextField
                            fullWidth
                            margin="dense"
                            id="apiUrl"
                            name="apiUrl"
                            label="API URL"
                            value={gatewayCredentials?.apiUrl || ""}
                            onChange={(e) => handleFieldChange("apiUrl", e.target.value)}
                            error={
                                formik.touched.gatewayCredentials?.apiUrl &&
                                Boolean(formik.errors.gatewayCredentials?.apiUrl)
                            }
                            helperText={
                                formik.touched.gatewayCredentials?.apiUrl &&
                                formik.errors.gatewayCredentials?.apiUrl
                            }
                        />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={6}>
                        <TextField
                            fullWidth
                            margin="dense"
                            id="profileId"
                            name="profileId"
                            label="Profile ID"
                            value={gatewayCredentials?.profileId || ""}
                            onChange={(e) => handleFieldChange("profileId", e.target.value)}
                            error={
                                formik.touched.gatewayCredentials?.profileId &&
                                Boolean(formik.errors.gatewayCredentials?.profileId)
                            }
                            helperText={
                                formik.touched.gatewayCredentials?.profileId &&
                                formik.errors.gatewayCredentials?.profileId
                            }
                        />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={6}>
                        <TextField
                            fullWidth
                            margin="dense"
                            id="profileKey"
                            name="profileKey"
                            label="Profile Key"
                            type="text"
                            value={gatewayCredentials?.profileKey || ""}
                            onChange={(e) => handleFieldChange("profileKey", e.target.value)}
                            error={
                                formik.touched.gatewayCredentials?.profileKey &&
                                Boolean(formik.errors.gatewayCredentials?.profileKey)
                            }
                            helperText={
                                formik.touched.gatewayCredentials?.profileKey &&
                                formik.errors.gatewayCredentials?.profileKey
                            }
                        />
                    </GridItem>
                </GridContainer>
            );

        case PAYMENT_METHODS.AUTHORIZE_NET:
            return (
                <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                        <TextField
                            fullWidth
                            margin="dense"
                            id="apiLoginId"
                            name="apiLoginId"
                            label="API Login Id"
                            value={gatewayCredentials?.apiLoginId || ""}
                            onChange={(e) => handleFieldChange("apiLoginId", e.target.value)}
                            error={
                                formik.touched.gatewayCredentials?.apiLoginId &&
                                Boolean(formik.errors.gatewayCredentials?.apiLoginId)
                            }
                            helperText={
                                formik.touched.gatewayCredentials?.apiLoginId &&
                                formik.errors.gatewayCredentials?.apiLoginId
                            }
                        />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={6}>
                        <TextField
                            fullWidth
                            margin="dense"
                            id="transactionKey"
                            name="transactionKey"
                            label="Transaction Key"
                            value={gatewayCredentials?.transactionKey || ""}
                            onChange={(e) => handleFieldChange("transactionKey", e.target.value)}
                            error={
                                formik.touched.gatewayCredentials?.transactionKey &&
                                Boolean(formik.errors.gatewayCredentials?.transactionKey)
                            }
                            helperText={
                                formik.touched.gatewayCredentials?.transactionKey &&
                                formik.errors.gatewayCredentials?.transactionKey
                            }
                        />
                    </GridItem>
                </GridContainer>
            );

        case PAYMENT_METHODS.STRIPE:
            return (
                <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                        <TextField
                            fullWidth
                            margin="dense"
                            id="publishableKey"
                            name="publishableKey"
                            label="Publishable Key"
                            value={gatewayCredentials?.publishableKey || ""}
                            onChange={(e) => handleFieldChange("publishableKey", e.target.value)}
                            error={
                                formik.touched.gatewayCredentials?.publishableKey &&
                                Boolean(formik.errors.gatewayCredentials?.publishableKey)
                            }
                            helperText={
                                formik.touched.gatewayCredentials?.publishableKey &&
                                formik.errors.gatewayCredentials?.publishableKey
                            }
                        />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={6}>
                        <TextField
                            fullWidth
                            margin="dense"
                            id="secretKey"
                            name="secretKey"
                            label="Secret Key"
                            value={gatewayCredentials?.secretKey || ""}
                            onChange={(e) => handleFieldChange("secretKey", e.target.value)}
                            error={
                                formik.touched.gatewayCredentials?.secretKey &&
                                Boolean(formik.errors.gatewayCredentials?.secretKey)
                            }
                            helperText={
                                formik.touched.gatewayCredentials?.secretKey &&
                                formik.errors.gatewayCredentials?.secretKey
                            }
                        />
                    </GridItem>
                </GridContainer>
            );

        case PAYMENT_METHODS.GLOBALSHOPEX:
            return (
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <TextField
                            fullWidth
                            margin="dense"
                            id="merchantId"
                            name="merchantId"
                            label="Merchant ID"
                            value={gatewayCredentials?.merchantId || ""}
                            onChange={(e) => handleFieldChange("merchantId", e.target.value)}
                        />
                    </GridItem>
                </GridContainer>
            );

        case PAYMENT_METHODS.DLOCAL:
            return (
                <GridContainer>
                    <GridItem xs={12} sm={6} md={6}>
                        <TextField
                            fullWidth
                            margin="dense"
                            id="xLogin"
                            name="xLogin"
                            label="X-Login"
                            value={gatewayCredentials?.xLogin || ""}
                            onChange={(e) => handleFieldChange("xLogin", e.target.value)}
                            error={
                                formik.touched.gatewayCredentials?.xLogin &&
                                Boolean(formik.errors.gatewayCredentials?.xLogin)
                            }
                            helperText={
                                formik.touched.gatewayCredentials?.xLogin &&
                                formik.errors.gatewayCredentials?.xLogin
                            }
                        />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={6}>
                        <TextField
                            fullWidth
                            margin="dense"
                            id="xTransKey"
                            name="xTransKey"
                            label="X-Trans-Key"
                            value={gatewayCredentials?.xTransKey || ""}
                            onChange={(e) => handleFieldChange("xTransKey", e.target.value)}
                            error={
                                formik.touched.gatewayCredentials?.xTransKey &&
                                Boolean(formik.errors.gatewayCredentials?.xTransKey)
                            }
                            helperText={
                                formik.touched.gatewayCredentials?.xTransKey &&
                                formik.errors.gatewayCredentials?.xTransKey
                            }
                        />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={6}>
                        <TextField
                            fullWidth
                            margin="dense"
                            id="secretKey"
                            name="secretKey"
                            label="Secret Key"
                            value={gatewayCredentials?.secretKey || ""}
                            onChange={(e) => handleFieldChange("secretKey", e.target.value)}
                            error={
                                formik.touched.gatewayCredentials?.secretKey &&
                                Boolean(formik.errors.gatewayCredentials?.secretKey)
                            }
                            helperText={
                                formik.touched.gatewayCredentials?.secretKey &&
                                formik.errors.gatewayCredentials?.secretKey
                            }
                        />
                    </GridItem>

                    <GridItem xs={12} sm={6} md={6}>
                        <TextField
                            fullWidth
                            margin="dense"
                            id="publicKey"
                            name="publicKey"
                            label="Public Key"
                            value={gatewayCredentials?.publicKey || ""}
                            onChange={(e) => handleFieldChange("publicKey", e.target.value)}
                            error={
                                formik.touched.gatewayCredentials?.publicKey &&
                                Boolean(formik.errors.gatewayCredentials?.publicKey)
                            }
                            helperText={
                                formik.touched.gatewayCredentials?.publicKey &&
                                formik.errors.gatewayCredentials?.publicKey
                            }
                        />
                    </GridItem>
                </GridContainer>
            );

        default:
            return null;
    }
};

export default PaymentMethodFields;
